import config from './player.config.json';

// A local transport/animation fixture, not an AI avatar or an Ant Media session.
// It never requests a camera/microphone or invents a drawn number.
export function localPreviewSource(label:()=>string, signal:AbortSignal){
  const canvas=document.createElement('canvas'),p=config.preview;
  canvas.width=p.width;canvas.height=p.height;
  const ctx=canvas.getContext('2d')!;
  const start=performance.now();
  const frame=()=>{
    const seconds=(performance.now()-start)/1000;
    ctx.fillStyle=p.background;ctx.fillRect(0,0,p.width,p.height);
    const glow=ctx.createRadialGradient(380,340,30,380,340,480);glow.addColorStop(0,'#443427');glow.addColorStop(1,p.background);
    ctx.fillStyle=glow;ctx.fillRect(0,0,p.width,p.height);
    ctx.strokeStyle=p.gold;ctx.lineWidth=5;ctx.beginPath();ctx.moveTo(215,320);ctx.lineTo(215,540);ctx.quadraticCurveTo(385,640,555,540);ctx.lineTo(555,320);ctx.stroke();
    ctx.fillStyle=p.gold;ctx.fillRect(368,593,34,44);ctx.fillRect(290,635,190,12);
    ctx.save();ctx.translate(385,350);ctx.rotate(seconds*.6);
    ctx.strokeStyle=p.gold;ctx.lineWidth=3;ctx.beginPath();ctx.arc(0,0,190,0,Math.PI*2);ctx.stroke();
    for(let index=0;index<8;index++){
      ctx.beginPath();ctx.ellipse(0,0,Math.max(3,Math.abs(Math.cos(index*Math.PI/8+seconds*.8))*190),190,0,0,Math.PI*2);ctx.stroke();
    }
    ctx.restore();
    for(let index=0;index<30;index++){
      const angle=index*2.39996+seconds*(.6+index%3*.12),radius=42+index%7*18;
      const x=385+Math.cos(angle)*radius,y=373+Math.sin(angle)*radius*.8;
      const ball=ctx.createRadialGradient(x-4,y-5,1,x,y,12);ball.addColorStop(0,'#fffce6');ball.addColorStop(.65,p.gold);ball.addColorStop(1,'#8f5d2b');
      ctx.fillStyle=ball;ctx.beginPath();ctx.arc(x,y,12,0,Math.PI*2);ctx.fill();
    }
    ctx.fillStyle=p.accent;ctx.font='600 22px system-ui';ctx.fillText(label(),690,270);
    ctx.fillStyle=p.ink;ctx.font='600 64px system-ui';ctx.fillText('90°',690,365);
    ctx.font='500 42px monospace';ctx.fillText(seconds.toFixed(1)+' s',690,440);
    ctx.fillStyle=p.gold;ctx.fillRect(690,490,Math.max(4,seconds%10/10*350),6);
  };
  frame();const timer=window.setInterval(frame,1000/p.framesPerSecond);
  const stream=canvas.captureStream(p.framesPerSecond);
  const stop=()=>{clearInterval(timer);stream.getTracks().forEach(track=>track.stop());};
  signal.addEventListener('abort',stop,{once:true});
  return {stream,stop};
}

export async function attachLocalPreview(video:HTMLVideoElement,label:()=>string,signal:AbortSignal){
  const fixture=localPreviewSource(label,signal);
  // A real sender -> receiver WebRTC hop within this browser, with no external STUN.
  const sender=new RTCPeerConnection({iceServers:[]}),receiver=new RTCPeerConnection({iceServers:[]});
  let stopped=false;
  const stop=()=>{if(stopped)return;stopped=true;sender.close();receiver.close();fixture.stop();video.srcObject=null;};
  signal.addEventListener('abort',stop,{once:true});
  const candidates=(from:RTCPeerConnection,to:RTCPeerConnection)=>{from.onicecandidate=event=>{if(event.candidate&&!signal.aborted)void to.addIceCandidate(event.candidate).catch(()=>{});};};
  candidates(sender,receiver);candidates(receiver,sender);
  receiver.ontrack=event=>{if(!signal.aborted)video.srcObject=event.streams[0]??new MediaStream([event.track]);};
  for(const track of fixture.stream.getTracks())sender.addTrack(track,fixture.stream);
  try{
    const offer=await sender.createOffer();if(signal.aborted)return stop;
    await sender.setLocalDescription(offer);if(signal.aborted)return stop;
    await receiver.setRemoteDescription(offer);if(signal.aborted)return stop;
    const answer=await receiver.createAnswer();if(signal.aborted)return stop;
    await receiver.setLocalDescription(answer);if(signal.aborted)return stop;
    await sender.setRemoteDescription(answer);
    return stop;
  }catch(error){stop();throw error;}
}
